
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15 6h.75V4.5h-3V3a1.5 1.5 0 00-1.5-1.5h-4.5A1.5 1.5 0 005.25 3v1.5h-3V6H3v9a1.5 1.5 0 001.5 1.5h9A1.5 1.5 0 0015 15V6zm-1.5 0h-9v9h9V6zM6.75 4.5h4.5V3h-4.5v1.5zm1.5 3v6h-1.5v-6h1.5zm3 6v-6h-1.5v6h1.5z","fill":"#363636"}})])
          )
        }
      }
    